var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,22.7H9c-5.4,0-7.8-2.3-7.8-7.7V9c0-5.4,2.3-7.8,7.8-7.8h6c5.4,0,7.8,2.3,7.8,7.8v6C22.8,20.4,20.4,22.7,15,22.7z M9,2.7 C4.4,2.7,2.8,4.4,2.8,9v6c0,4.6,1.6,6.2,6.3,6.2h6c4.6,0,6.3-1.6,6.3-6.2V9c0-4.6-1.6-6.3-6.3-6.3C15.1,2.7,9,2.7,9,2.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7,10.8l-1.5-1.3c-0.4-0.3-0.8-0.2-1.1,0c-0.3,0.4-0.2,0.8,0,1.1l0.1,0.1h-3.7c-0.2,0-0.4,0.1-0.5,0.2L11,12.1L8.8,9.9 C8.6,9.8,8.4,9.7,8.2,9.7C8,9.7,7.8,9.8,7.7,10l-2.1,2.8c-0.3,0.3-0.2,0.8,0.1,1.1C5.8,13.9,6,14,6.1,14c0.2,0,0.4-0.1,0.6-0.3 l1.6-2.1l2.1,2.1c0.3,0.3,0.8,0.3,1.1,0l1.4-1.4h3.4l-0.1,0.1c-0.3,0.4-0.2,0.8,0,1.1c0.3,0.3,0.7,0.3,1.1,0l1.3-1.5 C19,11.5,19,11.1,18.7,10.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.1,9.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendNo);
export default __webpack_public_path__ + "static/media/trend-no.307f91e038ee0fb4966ebccd43b94a6b.svg";
export { ForwardRef as ReactComponent };